/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_ProjectInputs */

const en_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Project`)
};

const fr_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet d’équipe`)
};

const de_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamprojekt`)
};

const it_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto di squadra`)
};

const ru_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командный проект`)
};

const es_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto de equipo`)
};

const zh_cn2_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队项目`)
};

const ja_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクト`)
};

const hi_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम परियोजना`)
};

const pt_pt2_team_project = /** @type {(inputs: Team_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto em Equipe`)
};

/**
* | output |
* | --- |
* | "Team Project" |
*
* @param {Team_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project = /** @type {((inputs?: Team_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project(inputs)
	if (locale === "de") return de_team_project(inputs)
	if (locale === "it") return it_team_project(inputs)
	if (locale === "ru") return ru_team_project(inputs)
	if (locale === "es") return es_team_project(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project(inputs)
	if (locale === "ja") return ja_team_project(inputs)
	if (locale === "hi") return hi_team_project(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project(inputs)
	return en_team_project(inputs)
});